import React from "react";
import { Link } from "react-router-dom";
import { Button, IconButton } from "../ui/Button/index.js";
import { LuMenu, LuX } from "react-icons/lu";
import { useTranslation } from "react-i18next";

/**
 * MobileMenu component that renders a responsive hamburger menu for mobile devices.
 * 
 * @param {Object} props - Component props.
 * @param {boolean} props.isNavOpen - State indicating if the mobile menu is open.
 * @param {Function} props.setIsNavOpen - Function to toggle the mobile menu state.
 * @param {Function} props.handleClick - Callback function to handle link clicks and close the menu.
 */
export default function MobileMenu({ isNavOpen, setIsNavOpen, handleClick }) {
    const { t } = useTranslation();
    const links = [
        { path: "/", labelKey: "home" },
        { path: "/search", labelKey: "search_persona" },
        { path: "/about", labelKey: "about_us" },
        { path: "/partner", labelKey: "partner_with_us" },
    ];

    return (
        <>
            <IconButton
                variant="ghost"
                size="icon"
                onClick={() => setIsNavOpen(!isNavOpen)}
                className="lg:hidden p-0"
                icon={
                    <LuMenu className="h-8 w-8" />
                }
            />
            {isNavOpen && (
                <div className="lg:hidden absolute top-0 left-0 py-2 px-2 h-screen w-screen bg-gray-100 bg-opacity-95 shadow-lg z-3">
                    <IconButton
                        variant="ghost"
                        size="icon"
                        onClick={() => setIsNavOpen(false)}
                        className="absolute top-8 right-10"
                        icon={
                            <LuX className="h-6 w-6" />
                        }
                    />
                    <nav className="pt-8 px-4">
                        <ul className="space-y-4">
                            {links.map(({ path, labelKey }) => (
                                <li key={path}>
                                    <Button
                                        as={Link}
                                        to={path}
                                        onClick={() => {
                                            handleClick();
                                            setIsNavOpen(false);
                                        }}
                                        variant="nav"
                                    >
                                        {t(labelKey)}
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            )}
        </>
    );
}
